import ApiService from '@/services/core/api.service'

const PendingService = {
  async get (query = '') {
    return ApiService.get(`executive-secretary/check-receiving?${query}`)
  },

  async post (payload) {
    return ApiService.post('executive-secretary/check-receiving', payload)
  },

  async put (payload) {
    return ApiService.put(`executive-secretary/check-receiving/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`executive-secretary/check-receiving/${payload.id}`)
  }
}

export default PendingService
